<template>
  <div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }">

    <h1>Sobre o Simulador do Eproc</h1>
    <p style="text-align: justify;">Esta plataforma foi desenvolvida exclusivamente para os alunos desta entidade. A TWM Simuladores é especialista em oferecer simuladores de peticionamento eletrônico que visam simplificar e aprimorar a prática jurídica digital.</p>
    <p style="text-align: justify;">Nossa plataforma foi criada para proporcionar uma experiência prática e realista no peticionamento eletrônico. Pratique de maneira eficiente antes mesmo do processo oficial, ganhando confiança e habilidade.</p>
    <p style="text-align: justify;">Desenvolvemos esta plataforma exclusivamente para atender às necessidades específicas desta entidade estudantil. Entendemos os desafios do seu dia a dia jurídico e projetamos ferramentas que se alinham diretamente às suas demandas.</p>
    <p style="text-align: justify;">Queremos garantir que você aproveite ao máximo a Plataforma TWM Simuladores. Para orientações detalhadas e instruções de uso, consulte nosso <a :href="`${BASE_URL}docs/ePROC_manual_aluno.pdf`" target="_blank">manual</a>.
    Embarque conosco nesta jornada de aprimoramento digital no peticionamento eletrônico. Na TWM Simuladores, estamos comprometidos em impulsionar o seu sucesso no mundo jurídico.
    </p>

    <p style="text-align: justify; margin-top: 20px;"><a :href="`${BASE_URL}docs/ePROC_manual_aluno.pdf`" target="_blank">Clique aqui para baixar o manual</a>.</p>

    <!-- Container Responsivo do Vídeo do YouTube -->
    <div class="video-wrapper">
      <iframe 
        src="https://www.youtube.com/embed/VHPo9FucVek" 
        title="Apresentação do Simulador Eproc" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen>
      </iframe>
    </div>


    <div style="text-align: center; margin-top: 30px;">
      <a href="https://twmsimuladores.com.br" target="_blank">
        <img :src="`${BASE_URL}imagens/juripraxis.png`" alt="Logo TWM Simuladores" class="logo" width="150">
      </a>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedFile: null,
      BASE_URL: window.Laravel.baseUrl,
    };
  },
  methods: {

  },
};
</script>

<style scoped>
/* Estilos para manter o vídeo responsivo, em proporção 16:9 e com design limpo */
.video-wrapper {
  position: relative;
  width: 100%;
  max-width: 720px; /* Limita a largura em monitores grandes */
  margin: 40px auto; /* Centraliza horizontalmente e dá respiro vertical */
  aspect-ratio: 16 / 9; /* Mantém a proporção correta do YouTube nativamente */
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1); /* Sombra elegante */
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>